import gql from 'graphql-tag';

export const ADD_TEXT_ASSET_ARTICLE_GROUP_MUTATION = gql`
  mutation AddTextAssetToArticleGroupMutation(
    $articleGroupId: ID!
    $text: String!
    $assetType: AssetTypeEnum!
    $engagementScore: Int
    $postMaloneProjectId: ID
  ) {
    addTextAssetToArticleGroup(
      articleGroupId: $articleGroupId
      text: $text
      assetType: $assetType
      engagementScore: $engagementScore
    ) {
      textAsset {
        id
        text
        postMaloneScore(postMaloneProjectId: $postMaloneProjectId) {
          engagementScore
          sourceType
        }
      }
      errors
    }
  }
`;
